import { mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters({
            userCurrentContext: 'userCurrentContext'
        }),

        annualDataYears () {
            const startYear = 2023
            const years = []
            for (let i = startYear; i <= this.reviewYear; i++) {
                years.push(i)
            }

            return years
        },

        reviewYear () {
            const currentDate = this.$moment.utc().utcOffset('-06:00')
            return ((currentDate.month() + 1) === 1 && currentDate.date() <= 20)
                ? currentDate.year() - 1
                : currentDate.year()
        },

        isStartReviewFromCurrentDate () {
            return this.$route.query && this.$route.query['startReviewFromCurrentDate'] === 'true'
        },

        annualDataReviewStartDate () {
            return this.isStartReviewFromCurrentDate
                ? this.$moment.utc().utcOffset('-06:00').startOf('day')
                : this.$moment.utc(`11/15/${this.reviewYear}`, 'MM/DD/YYYY').utcOffset('-06:00', true).startOf('day')
        },

        annualDataReviewEndDate () {
            return this.$moment.utc(`01/20/${this.reviewYear + 1}`, 'MM/DD/YYYY').utcOffset('-06:00', true).endOf('day')
        },

        isWithinAnnualDataReviewWindow () {
            const year = this.$route.params['year']
            if (year && year < this.reviewYear) {
                return false
            }

            const current = this.$moment.utc().utcOffset('-06:00')
            return current.isSameOrAfter(this.annualDataReviewStartDate) &&
                current.isSameOrBefore(this.annualDataReviewEndDate)
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/annualData.js